import { DeviceMicStateV2 } from '@shure/shared/angular/data-access/system-api/models';

import { MicStatusV2 } from '../graphql/generated/cloud-sys-api';

export function mapMicStatusV2FromSysApi(micStatus: MicStatusV2 | null | undefined): DeviceMicStateV2 {
	switch (micStatus) {
		case MicStatusV2.Active:
			return DeviceMicStateV2.Active;
		case MicStatusV2.Mute:
			return DeviceMicStateV2.Mute;
		case MicStatusV2.OnCharger:
			return DeviceMicStateV2.OnCharger;
		default:
			return DeviceMicStateV2.Unknown;
	}
}
